import { AsyncInteractor } from "@kernel/frontend-react-app";
import { StatsRepositoryService } from "../services";
import { StatsIndexDto } from "@domain";

export interface RemoveStatsFileService {
  remove(name: string): Promise<StatsIndexDto>;
}

export interface RemoveStatsFileInteractorProps {
  name: string;
}

export class RemoveStatsFileInteractor extends AsyncInteractor<
  RemoveStatsFileService,
  RemoveStatsFileInteractorProps,
  StatsIndexDto
> {
  public async execute(
    props: RemoveStatsFileInteractorProps
  ): Promise<StatsIndexDto> {
    return await this.service.remove(props.name);
  }

  public static create() {
    const service = new StatsRepositoryService();
    return new RemoveStatsFileInteractor(service);
  }
}
